import http from 'plugins/axios';

export default {

    getCoinList(data) {
        return http.get({
            url: '/admin/deposit/audit/listRecord',
            data
        });
    },

    syncCoin() {
        return http.get({
            url: '/admin/deposit/audit/syncCoin'
        });
    },

    setLimit(data) {
        return http.post({
            url: '/admin/deposit/audit/setLimit',
            data,
            dataType: 'form'
        })
    },


    addBlackList(data) {
        return http.post({
            url: '/admin/deposit/blackList/addIn',
            data,
            dataType: 'form'
        })
    },

    deleteBlackList(data) {
        return http.post({
            url: '/admin/deposit/blackList/deleteByUid',
            data,
            dataType: 'form'
        })
    },

    getBlackList(data) {
        return http.get({
            url: '/admin/deposit/blackList/list',
            data
        });
    },


    addWhiteList(data) {
        return http.post({
            url: '/admin/deposit/whiteList/addIn',
            data,
            dataType: 'form'
        })
    },

    deleteWhiteList(data) {
        return http.post({
            url: '/admin/deposit/whiteList/deleteByUid',
            data,
            dataType: 'form'
        })
    },

    getWhiteList(data) {
        return http.get({
            url: '/admin/deposit/whiteList/list',
            data
        });
    },

    findByCoin(data) {
        return http.get({
            url: '/admin/deposit/audit/v2/findByCoin',
            data
        })
    },

    deleteLimit(data) {
        return http.post({
            url: '/admin/deposit/audit/deleteByCoinType',
            data,
            dataType: 'form'
        })
    },


};
